var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars-wrapper"},_vm._l((5),function(index){return _c('img',{key:index,attrs:{"width":_vm.width,"height":_vm.width,"src":index <= _vm.score ? _vm.red : _vm.gray,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }